import { AppShell } from './shell/AppShell.tsx';

export function App() {
  return <AppShell />;
}
